@if (attachment) {
  <div class="d-flex flex-row flex-wrap flex-lg-nowrap card-container mt-1 mb-3 gap-3" data-test="attachment-info">

    <div class="order-lg-1 thumbnail-wrapper">
      <ds-thumbnail [thumbnail]="thumbnail$ | async"></ds-thumbnail>
    </div>

    <div class="order-lg-3 ml-auto">
      <div class="d-flex flex-column align-items-end gap-3">
        @for (renderingType of allAttachmentProviders;  track $index) {
          <div class="text-nowrap">
            <ds-attachment-render [renderingType]="renderingType" [bitstream]="attachment" [item]="item" [tabName]="tabName"></ds-attachment-render>
          </div>
        }
        <!-- Default download button -->
        <div class="text-nowrap">
          <ds-attachment-render [renderingType]="AttachmentRenderingType.DOWNLOAD" [bitstream]="attachment" [item]="item" [tabName]="tabName"></ds-attachment-render>
        </div>
      </div>
    </div>

    <div class="order-lg-2 w-100 mb-3">
      @for (attachmentConf of envMetadata;  track $index) {
        @if (attachment.firstMetadataValue(attachmentConf.name) || attachmentConf.type === AdvancedAttachmentElementType.Attribute) {
          <div class="content" [attr.data-test]="attachmentConf.name">
            <strong>{{ 'cris-layout.advanced-attachment.' + attachmentConf.name | translate }}</strong>

            @if (attachmentConf.type === AdvancedAttachmentElementType.Metadata) {

              @if(!attachmentConf.truncatable && attachmentConf.name === attachmentTypeMetadata) {
                <p class="text-break m-0">
                  {{attachment.firstMetadataValue(attachmentConf.name) | titlecase}}
                </p>
              }

              @if(!attachmentConf.truncatable && attachmentConf.name !== attachmentTypeMetadata) {
                <p class="text-break m-0">
                  {{attachment.firstMetadataValue(attachmentConf.name)}}
                </p>
              }

              @if (attachmentConf.truncatable) {
                <ds-truncatable [id]=" attachment.id">
                  <ds-truncatable-part [id]="attachment.id" [minLines]="1">
                    {{attachment.firstMetadataValue(attachmentConf.name)}}
                  </ds-truncatable-part>
                </ds-truncatable>
              }
            }
            @if (attachmentConf.type === AdvancedAttachmentElementType.Attribute) {
              @if (attachmentConf.name === 'format') {
                @if ((bitstreamFormat$ | async) === null || (bitstreamFormat$ | async) === undefined) {
                  <p class="text-muted">
                    {{'cris-layout.advanced-attachment.label.not-present' | translate}}
                  </p>
                } @else {
                  <p class="word-break m-0">{{(bitstreamFormat$ | async)}}</p>
                }
              }

              @if (attachmentConf.name === 'size' && bitstreamSize) {
                <p class="word-break m-0">{{bitstreamSize | dsFileSize}}</p>
              }

              @if (attachmentConf.name === 'checksum') {
                @if (checksumInfo?.value === null || checksumInfo?.value === undefined) {
                  <p class="text-muted">
                    {{'cris-layout.advanced-attachment.label.not-present' | translate}}
                  </p>
                } @else {
                  <p class="word-break m-0">({{checksumInfo.checkSumAlgorithm}}):{{ checksumInfo.value }}</p>
                }
              }
            }

          </div>
        }
      }

    </div>

  </div>
}
